<template>
  <div class="report-page">
    <iframe class="report-page__iframe" :src="formstackUrl"></iframe>
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";

const URL_MAP = {
  en: "https://ccncto.formstack.com/forms/racismcoviden_1",
  fr: "https://ccncto.formstack.com/forms/racismcovidfr",
  zhcn: "https://ccncto.formstack.com/forms/racismcovidzhsimplified",
  zhtw: "https://ccncto.formstack.com/forms/racismcovidtraditional"
};

export default {
  name: "ReportPage",
  component: { Footer },
  computed: {
    formstackUrl() {
      let locale = this.$i18n.locale;
      return URL_MAP[locale] || URL_MAP["en"];
    }
  }
};
</script>
<style>
.report-page {
  height: 100vh;
  width: 100%;
  position: relative;
}
.report-page__iframe {
  min-width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
